import gsap from 'gsap'
import Image from 'next/image'
import React, { useEffect, useRef } from "react"

export default function Modal({modal, projects}) {

  const {active, index} = modal
  const modalContainer = useRef(null)
  const modalSlider = useRef(null)

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: "power3.inOut", duration: 0.4 } })
    if (active) {
      tl.fromTo(modalContainer.current, { scale: 0, top: "50%", left: "75%", xPercent: -50, yPercent: -50 }, { scale: 1, left: "75%" })
    } else {
      tl.to(modalContainer.current, { scale: 0, opacity: 1 })
    }
  }, [active])


  return (
    <>
      <div ref={modalContainer} className="h-[350px] w-[400px] fixed top-0 left-0 z-50 overflow-hidden pointer-events-none flex items-center justify-center opacity-0 rounded-3xl">
        <div
          ref={modalSlider}
          className="absolute h-full w-full"
          style={{
            top: `${index * -100}%`,
            transition: "top 0.5s cubic-bezier(0.76, 0, 0.24, 1)"
          }}
        >
          {projects.map((project, index) => {

            return (
              <div key={index} className="relative flex items-center justify-center h-[350px] w-[400px] overflow-hidden">
                <Image src={project._embedded["wp:featuredmedia"][0]?.source_url} alt={project._embedded["wp:featuredmedia"][0]?.alt_text} width={400} height={350} className="object-cover rounded-3xl w-full h-full" />
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
